<span *ngIf="activeUserId === data.value.activeUserId" class="fw-bold" data-test-id="activity-shared-you">{{
  'ACTIVITY_YOU' | translate
}}</span>
<app-activities-navigate-profile
  *ngIf="activeUserId !== data.value.activeUserId"
  [user]="data.value.ownerItem"
  [isDialog]="isDialog"
  [dataTestId]="'activity-shared-navigate-to-profile'"
  (submit)="onSubmit()"
></app-activities-navigate-profile>

<span>&nbsp;{{ 'ACTIVITY_SHARED' | translate }}</span>
<span *ngIf="isDialog" data-test-id="activity-shared-this">&nbsp;{{ 'ACTIVITY_THIS' | translate }}</span>
<span>&nbsp;{{ 'ACTIVITY_FILE' | translate }}</span>
<app-activities-display-popup
  *ngIf="!isDialog"
  [rowIndex]="data.rowIndex"
  [value]="data?.value"
  [entityName]="data.value.entity_name"
  [dataTestId]="'activity-shared-file-'"
  (displayPopup)="onDisplayPopup($event)"
></app-activities-display-popup>

{{ 'ACTIVITY_WITH' | translate }}
<span *ngFor="let user of data.value.users; index as i">
  <app-activities-navigate-profile
    [user]="user"
    [isDialog]="isDialog"
    [isActiveUser]="activeUserId === user.user_id"
    [needComma]="i < data.value.users.length - 1"
    [dataTestId]="'activity-shared-file-name-' + i"
    (submit)="onSubmit()"
  ></app-activities-navigate-profile>
</span>
